import React from "react";
import Image from "components/Image";
import { getConfig } from "utils/env";

const Brand = () => (
  <Image
    src={`${getConfig("BASE_PATH")}/assets/brand.png`}
    width="40"
    height="40"
    alt={"PriceBlocs Logo"}
  />
);

export default Brand;
